/** Assignment Status */
export enum Status {
  None,
  Created,
  ResourceAssigned,
  ResourceAsked,
  ResourceConfirmed,
  ResourceReported,
  Billed,
  Cancelled,
}

/** Assignment Status Autocomplete */
export enum StatusAutocomplete {
  None,
  Created,
  ResourceAssigned,
  ResourceAsked,
  ResourceConfirmed,
  ResourceReported,
  Billed,
  Cancelled,
  PriceCalculated = -2, // hasPriceCalculated is true.
  CancelledLate = -3, // Status is Cancelled and isCancelledLate is true.
  ReportedWithSignature = -4, // Status is ResourceReported and report.hasSignature is true.
}
